export function formatTime(input_time) {
    const [startHours, startMinutes] = input_time.split(':');

    const formattedStartHours = parseInt(startHours, 10).toString();

    return `${formattedStartHours}:${startMinutes}`;
}